import { INTERCOM_CARD_RADIUS } from './intercomLayoutTokens';

/** Matches Intercom home cards: 1px #ededed border + dual-layer shadow. */
export const INTERCOM_CARD_STYLE = {
  boxShadow:
    '0 4px 28px 0 rgba(9, 14, 21, 0.06), 0 1px 4px 0 rgba(9, 14, 21, 0.06)',
};

export const INTERCOM_CARD_CLASS = `relative box-border overflow-hidden border border-solid border-[#ededed] bg-white ${INTERCOM_CARD_RADIUS}`;
